import { useInternalDynamicContext } from '../../../context/DynamicContext/useInternalDynamicContext.js';
import { getEnabledKYC } from '../../functions/getEnabledKYC/index.js';
import { useOnlyConnectedMode } from '../useOnlyConnectedMode/useOnlyConnectedMode.js';

const useKYCFlag = () => {
    var _a;
    const isOnlyConnected = useOnlyConnectedMode();
    const { projectSettings } = useInternalDynamicContext();
    const hasKYCSettings = (_a = getEnabledKYC(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc)) === null || _a === void 0 ? void 0 : _a.length;
    return !isOnlyConnected && Boolean(hasKYCSettings);
};

export { useKYCFlag };
